import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Header";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/previous-result", label: "Previous Result" },
  { to: "/common-number", label: "Common Number" },
  { to: "/dream-number", label: "Dream Number" },
  { to: "/result-history", label: "Result History" },
  { to: "/calendar", label: "Teer Calendar" },
  { to: "/analysis", label: "Analysis" },
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms & Conditions" },
];

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 bg-brand-900 text-white" data-testid="site-footer">
      <div className="w-full max-w-md mx-auto sm:max-w-xl md:max-w-4xl lg:max-w-6xl px-4 md:px-6 py-10">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div className="max-w-sm">
            <div className="bg-white/10 rounded-xl px-3 py-2 inline-block backdrop-blur">
              <Logo light />
            </div>
            <p className="text-sm text-violet-200 mt-4 leading-relaxed">
              Daily Morning Teer results and archives for informational and reference
              purposes only. We do not offer betting, predictions or recommendations.
            </p>
          </div>
          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-wider text-violet-300 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+|&/g, "-")}`}
                    className="text-sm text-violet-200 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-8 pt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-violet-300">
            © {year} Guwahati Morning Teer. All rights reserved.
          </p>
          <p className="text-xs text-violet-300">
            For informational use only · Not affiliated with any lottery authority.
          </p>
        </div>
      </div>
    </footer>
  );
}
